module.exports = __webpack_public_path__ + "static/media/money-check-edit.0d8d4904.svg";